import types from '../actions/search/types';

const initialState = {
  artistsSlugs: {},
  currentPage: 1,
  filters: [],
  isLoading: false,
  isLoadingFilters: false,
  results: [],
  resultsCount: 0,
  resultsShown: 0,
  seoData: {},
  moreResultsAvailable: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.FETCH_SEARCH_FILTERS:
      return { ...state, isLoadingFilters: true };
    case types.FETCH_SEARCH_FILTERS_SUCCESS: {
      const artistsFilters = action.payload
        .filter(filter => filter.filter_name === 'artwork');
      const artistsCategories = artistsFilters[0].filters.filter(filter => filter.slug === 'artist-term');
      const artistsSlugs = artistsCategories[0].categories.reduce((slugs, artist) => {
        slugs[`${artist.slug}`] = artist.name;
        return slugs;
      }, {});
      return { ...state, isLoadingFilters: false, filters: action.payload, artistsSlugs };
    }
    case types.FETCH_SEO_DATA:
      return { ...state, seoData: {} };
    case types.FETCH_SEO_DATA_SUCCESS:
      return { ...state, seoData: action.payload.seoData };
    case types.FETCH_SEARCH_RESULTS:
      return { ...state, isLoading: true, results: [] };
    case types.FETCH_SEARCH_RESULTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        results: action.payload.results,
        resultsCount: parseInt(action.payload.page.posts_total, 10),
        resultsShown: parseInt(action.payload.page.posts_shown, 10),
        moreResultsAvailable:
          parseInt(action.payload.page.current_page, 10) < action.payload.page.pages_total,
        currentPage: parseInt(action.payload.page.current_page, 10),
      };
    case types.FETCH_MORE_SEARCH_RESULTS:
      return {
        ...state,
        isLoading: true,
      };
    case types.FETCH_MORE_SEARCH_RESULTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        results: [...state.results, ...action.payload.results],
        resultsCount: parseInt(action.payload.page.posts_total, 10),
        resultsShown: parseInt(action.payload.page.posts_shown, 10),
        moreResultsAvailable:
          parseInt(action.payload.page.current_page, 10) < action.payload.page.pages_total,
        currentPage: parseInt(action.payload.page.current_page, 10),
      };
    default:
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/app/reducers/search.js